<script lang="ts">
import { defineComponent } from 'vue';

import type { NTable } from './interface';

export type TColumnGroupProps<RecordType = NTable.TDefaultRecord> = NTable.NColumn.IColumn<RecordType>;

/**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */
export default defineComponent<TColumnGroupProps>({
  name: 'CdsTableColumnGroup',
  slots: ['title', 'default'],
  __CDS_TABLE_COLUMN_GROUP: true,
  render() {
    return null;
  }
});
</script>
